function isObject<T extends object>(val: T): val is T {
  return val.constructor === Object;
}

function isNumber(val: number) {
  return !isNaN(parseFloat(val?.toString())) && isFinite(val);
}

function isBoolean(val: unknown) {
  return val === 'false' || val === 'true';
}

function isArray(val: unknown) {
  return Array.isArray(val);
}

function parseValue(val: any) {
  if (typeof val === 'undefined' || val === '') {
    return null;
  } else if (isBoolean(val)) {
    return parseBoolean(val);
  } else if (isArray(val)) {
    return parseArray(val);
  } else if (isObject(val)) {
    return parseObject(val);
  } else if (isNumber(val)) {
    return parseNumber(val);
  } else {
    return val;
  }
}

export function parseObject(obj: any): Record<string, any> {
  const result: Record<string, any> = {};
  let key, val;
  for (key in obj) {
    val = parseValue(obj[key]);
    if (val !== null) {
      result[key] = val;
    }
  }
  return result;
}

function parseArray(arr: any): any[] {
  const result = [];
  for (let i = 0; i < arr.length; i++) {
    result[i] = parseValue(arr[i]);
  }
  return result;
}

function parseNumber(val: string) {
  return Number(val);
}

function parseBoolean(val: string) {
  return val === 'true';
}
